import { Icon, IconProps } from './Icon';

export type TwitterProps = IconProps;

export const Twitter = (props: TwitterProps) => (
  <Icon width="48px" height="48px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path d="M44 11.6a16.983 16.983 0 0 1-4.72 1.28 8.26 8.26 0 0 0 3.62-4.54 16.421 16.421 0 0 1-5.22 2 8.2 8.2 0 0 0-14 7.48 23.281 23.281 0 0 1-16.9-8.58 8.32 8.32 0 0 0-1.1 4.14 8.18 8.18 0 0 0 3.64 6.82 8.1 8.1 0 0 1-3.72-1.02v.1a8.2 8.2 0 0 0 6.6 8 7.862 7.862 0 0 1-2.2.34 9.815 9.815 0 0 1-1.54-.14 8.22 8.22 0 0 0 7.66 5.68A16.44 16.44 0 0 1 6 36.68a15.88 15.88 0 0 1-2-.12 23.14 23.14 0 0 0 12.58 3.7A23.18 23.18 0 0 0 40 16.9v-1.06a16.86 16.86 0 0 0 4-4.24Z" fill="currentcolor"/>
  </Icon>
)
